Date.prototype.format = function (pat) {

    var year = this.getFullYear();
    var month = this.getMonth() + 1;
    var day = this.getDate();
    var hour = this.getHours();
    var minute = this.getMinutes();
    var second = this.getSeconds();

    // 两位补齐
    var autocomplete = function (int) {
        return int > 9 ? int : "0" + int;
    };

    if (!pat) {
        pat = "YYYY-MM-DD";
    }

    pat = pat.replace(/YYYY/g, year);
    pat = pat.replace(/MM/g, autocomplete(month));
    pat = pat.replace(/DD/g, autocomplete(day));
    pat = pat.replace(/hh/gi, autocomplete(hour));
    pat = pat.replace(/mm/g, autocomplete(minute));
    pat = pat.replace(/ss/g, autocomplete(second));

    return pat;
};